import { inject, injectable } from 'inversify';
import { NetworkDependencyTypes } from '@shared/common/network/network.dependency-types';

@injectable()
export class JwtLocalStorageService {
  public constructor(
    @inject(NetworkDependencyTypes.JwtLocalStorageKey)
    private readonly storageKey: string,
  ) {}

  public save(token: string): void {
    if (!this.canUseLocalStorage()) {
      return;
    }

    window.localStorage.setItem(this.storageKey, token);
  }

  public get(): string | null {
    if (!this.canUseLocalStorage()) {
      return null;
    }

    return window.localStorage.getItem(this.storageKey);
  }

  public clear(): void {
    if (!this.canUseLocalStorage()) {
      return;
    }

    window.localStorage.removeItem(this.storageKey);
  }

  private canUseLocalStorage(): boolean {
    return typeof window !== 'undefined' && typeof window.localStorage !== 'undefined';
  }
}
